
<app-header></app-header>
<app-right-side></app-right-side>
<app-conf-header></app-conf-header>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="../../../assets/img/loader.webp">
</div>
<div class="container">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-title">
                    <h6 class="title">News / Blogs</h6>
                </div>
                <div class="ui-block-content">
                    <form class="content" [formGroup]="newsForm" (ngSubmit)="postNews()">
                        <div class="row">
                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label">Select Type <span style="color: red;"> *
                                        </span></label>
                                    <select class="form-control" formControlName="newsType" (change)="onChange($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.newsType.errors }">
                                        <option value="News" selected>News</option>
                                        <option value="Blog">Blogs</option>
                                    </select>
                                    <div *ngIf="submitted && f.newsType.errors" class="invalid-feedback">
                                        <div *ngIf="f.newsType.errors.required">Type is required *</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Title <span style="color: red;"> *
                                        </span></label>
                                    <input type="text" formControlName="newsTitle" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.newsTitle.errors }" />
                                    <div *ngIf="submitted && f.newsTitle.errors" class="invalid-feedback">
                                        <div *ngIf="f.newsTitle.errors.required">Title is required *</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Content <span style="color: red;"> *
                                        </span> </label>
                                    <textarea class="form-control" name="newsContent" formControlName="newsContent"
                                        placeholder="Details..."
                                        [ngClass]="{ 'is-invalid': submitted && f.newsContent.errors }"></textarea>
                                    <div *ngIf="submitted && f.newsContent.errors" class="invalid-feedback">
                                        <div *ngIf="f.newsContent.errors.required">Content is required *</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Attachment <span style="color: red;"> *
                                        </span></label>
                                    <input type="file" formControlName="newsAttachment" class="form-control"
                                        (change)="onFileSelect($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.newsAttachment.errors }" />
                                    <div *ngIf=" submitted && f.newsAttachment.errors " class="invalid-feedback ">
                                        <div *ngIf="f.newsAttachment.errors.required ">Attachment is required *</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <button class="btn btn-primary btn-lg full-width">
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12">
            <div class="ui-block ">
                <div class="your-profile">
                    <div id="accordion " role="tablist " aria-multiselectable="true ">
                        <div class="card ">
                            <div class="card-header " role="tab " id="headingOne ">
                                <h6 class="mb-0 ">
                                    <a data-toggle="collapse " data-parent="#accordion " href="#collapseOne "
                                        aria-expanded="true " aria-controls="collapseOne ">
                                        Dashboard Settings
                                        <svg class="olymp-dropdown-arrow-icon ">
                                            <use xlink:href="#olymp-dropdown-arrow-icon "></use>
                                        </svg>
                                    </a>
                                </h6>
                            </div>
                            <div id="collapseOne " class="collapse show " role="tabpanel "
                                aria-labelledby="headingOne ">
                                <ul class="your-profile-menu ">
                                    <li class="active ">
                                        <a routerLink="/conf-dashboard" [queryParams]="{ 'id': confederationData.id}"
                                            routerLinkActive="active "> Add News/Blogs</a>
                                    </li>
                                    <li>
                                        <a routerLink="/conf-dashboard-photos"
                                            [queryParams]="{ 'id': confederationData.id}" routerLinkActive="active ">
                                            Add Photos/Videos</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>